import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const benefits = [
  { icon: '⚡', title: 'Fast Response', desc: 'On-site in 30-45 minutes for local mobile tire repair in NYC.' },
  { icon: '💰', title: 'Affordable', desc: 'Competitive pricing with no hidden fees, ever.' },
  { icon: '🤝', title: 'Honest Pricing', desc: 'No hidden fees - just transparent, local tire help service.' },
  { icon: '📍', title: 'Local Experts', desc: 'We know NYC roads and how to get you moving safely.' },
  { icon: '🔒', title: 'Safety First', desc: 'All tires are inspected and verified safe before installation.' },
];

const services = [
  { icon: '🚗', title: 'Mobile Tire Change', description: 'At your home, workplace, or roadside', detail: 'We come directly to your location - whether you\'re at home, at work, or stranded on the roadside. Our mobile tire change service gets you back on the road fast without the hassle of a tow truck.' },
  { icon: '♻️', title: 'Mobile Used Tire Replacement', description: 'Affordable, reliable used tires installed on-site', detail: 'Need a budget-friendly option? We bring quality used tires directly to you and install them on-site. All used tires are inspected for safety before installation.' },
  { icon: '🆘', title: '24/7 Emergency Roadside Tire Service', description: 'Day or night, weekend or weekday, we\'re ready to help', detail: 'Tire emergencies don\'t follow a schedule. That\'s why we\'re available 24/7 - including weekends and holidays. Just call us and help is already on the way.' },
  { icon: '💰', title: 'Affordable Used Tire Options', description: 'When a new tire isn\'t necessary', detail: 'Not every situation calls for a brand new tire. We offer quality used tires at affordable prices - inspected, tested and ready to install.' },
];

const steps = [
  { num: '01', icon: '📞', title: 'Call or Message Us', desc: 'Tell us where you are and what\'s going on with your tire. We\'ll confirm your location and explain the next steps - no pressure, no sales talk.' },
  { num: '02', icon: '🚐', title: 'We Come to You', desc: 'A mobile technician is dispatched right away. Most drivers are helped within 30–45 minutes, whether at home, work, or roadside.' },
  { num: '03', icon: '✅', title: 'Tire Fixed On-Site', desc: 'We safely change or replace your tire on-site. Clear pricing, straightforward service, and a simple explanation before any work is done.' },
];

const Services = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const [currentBenefit, setCurrentBenefit] = useState(0);
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  

  return (
    <div ref={ref}>
      <style>{`
      .benefits-marquee {
        overflow: hidden;
        width: 100%;
        position: relative;
      }

      .benefits-track {
        display: flex;
        gap: 16px;
        width: max-content;
        animation: benefitsScroll 25s linear infinite;
      }

      /* Each card should behave like inline marquee item */
      .benefits-track > div {
        flex: 0 0 220px;
      }

      /* Smooth infinite scroll right → left */
      @keyframes benefitsScroll {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-50%);
        }
      }

      /* Pause on hover (professional UX) */
      .benefits-marquee:hover .benefits-track {
        animation-play-state: paused;
      }

      /* MOBILE FIX */
      @media (max-width: 600px) {
        .benefits-track > div {
          flex: 0 0 180px;
        }

        .benefits-track {
          animation-duration: 18s;
        }
      }
        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 16px;
        }
        .steps-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 40px;
          position: relative;
        }
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
          gap: 24px;
          text-align: left;
        }
        .step-connector {
          position: absolute;
          top: 60px;
          right: -20px;
          width: 40px;
          height: 2px;
          background: rgba(255,255,255,0.2);
        }
        @media (max-width: 900px) {
          .benefits-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }
        }
        @media (max-width: 600px) {
          .benefits-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .steps-grid {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
          }
          .step-connector {
            display: none !important;
          }
          .services-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>

      {/* ── WHY CHOOSE US ── */}
      <div style={styles.whySection}>
        <div style={styles.container}>
          <p style={styles.tag}>WHY CHOOSE US</p>
          <h2 style={styles.whyTitle}>Why Choose Empire1Tires</h2>
          <p style={styles.whySubtitle}>
            We understand the urgency of a flat tire. Here's why drivers trust us.<br />
            <strong>24/7 Fast, Reliable Tire Repair Anytime, Anywhere</strong> - it's our promise.
          </p>

          <div className="benefits-marquee">
          <div className="benefits-track">
            {benefits.map((b, i) => (
              <div
                key={i}
                style={{
                  ...styles.benefitCard,
                  background: '#fff',
                  transform: 'translateY(0)',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                  transition: 'all 0.3s ease'
                                    
                }}
              >
                <span style={styles.benefitIcon}>{b.icon}</span>
                <h4 style={styles.benefitTitle}>{b.title}</h4>
                <p style={styles.benefitDesc}>{b.desc}</p></div>
            ))}
            
            {benefits.map((b, i) => (
              <div
                key={i}
                style={{
                  ...styles.benefitCard,
                  background: '#fff',
                  transform: 'translateY(0)',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                  transition: 'all 0.3s ease'
                }}
              >
                <span style={styles.benefitIcon}>{b.icon}</span>
                <h4 style={{ ...styles.benefitTitle, color: i === currentBenefit ? 'rgba(10, 10, 10, 0.85)' : '#4a5568' }}>{b.title}</h4>
                <p style={{ ...styles.benefitDesc, color: i === currentBenefit ? 'rgba(4, 3, 3, 0.85)' : '#4a5568' }}>{b.desc}</p>
              </div>
            ))}
            
            
            </div>


          </div>

          <div style={styles.dots}>
            {benefits.map((_, i) => (
              <div
                key={i}
                onClick={() => setCurrentBenefit(i)}
                style={{
                  ...styles.dot,
                  background: i === currentBenefit ? '#c41e3a' : '#e2e8f0',
                  width: i === currentBenefit ? '24px' : '8px'
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ── TIRE SERVICES ── */}
      <div style={styles.servicesSection}>
        <div style={styles.container}>
          <p style={styles.tag}>OUR SERVICES</p>
          <h2 style={styles.servicesTitle}>Tire Services Available in NYC</h2>
          <p style={styles.servicesSubtitle}>
            Stuck with a flat tire in Clark? Whether you're commuting along Westfield Avenue,
            Rahway River Parkway, or the Garden State Parkway, Empire Wheels comes directly
            to your location. We provide fast, affordable mobile tire changes and used tire
            replacements, so you can safely get back on the road. Help is already on the way.
          </p>

          <div className="services-grid">
            {services.map((service, i) => (
              <div
                key={i}
                style={{
                  ...styles.serviceCard,
                  borderColor: selected === i ? '#c41e3a' : '#e2e8f0',
                  boxShadow: selected === i ? '0 8px 32px rgba(196,30,58,0.15)' : '0 2px 12px rgba(26,58,92,0.05)',
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'translateY(0)' : 'translateY(30px)',
                  transition: `opacity 0.6s ease ${i * 0.1}s, transform 0.6s ease ${i * 0.1}s, border-color 0.25s, box-shadow 0.25s`
                }}
                onClick={() => setSelected(selected === i ? null : i)}
              >
                <div style={styles.serviceIconBox}>
                  <span style={styles.serviceIcon}>{service.icon}</span>
                </div>
                <h3 style={styles.serviceTitle}>{service.title}</h3>
                <p style={styles.serviceDesc}>{service.description}</p>
                <p style={styles.clickHint}>{selected === i ? '▲ Less info' : '▼ Learn more'}</p>
                {selected === i && (
                  <div style={styles.expandedBox}>
                    <p style={styles.detailText}>{service.detail}</p>
                    <button
                      style={styles.bookBtn}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/service-booking', { state: { service: service.title } });
                      }}
                    >
                      📞 Book This Service
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── 3-STEP PROCESS ── */}
      <div style={styles.processSection}>
        <div style={styles.processBg} />
        <div style={styles.processOverlay} />
        <div style={{ ...styles.container, position: 'relative', zIndex: 2 }}>
          <p style={{ ...styles.tag, color: '#c41e3a' }}>HOW IT WORKS</p>
          <h2 style={{ color: '#fff', fontSize: '36px', fontWeight: 'bold', marginBottom: '48px' }}>
            Our Simple 3-Step Process
          </h2>

          <div className="steps-grid">
            {steps.map((step, i) => (
              <div key={i} style={{ textAlign: 'center', position: 'relative' }}>
                <div style={{
                  ...styles.stepCircleOuter,
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'scale(1)' : 'scale(0.8)',
                  transition: `opacity 0.6s ease ${0.2 + i * 0.15}s, transform 0.6s ease ${0.2 + i * 0.15}s`
                }}>
                  <div style={styles.stepCircleInner}>
                    <span style={{ fontSize: '36px' }}>{step.icon}</span>
                  </div>
                  <div style={styles.stepNum}>{step.num}</div>
                </div>
                {i < steps.length - 1 && <div className="step-connector" />}
                <h3 style={{
                  ...styles.stepTitle,
                  opacity: visible ? 1 : 0,
                  transition: `opacity 0.6s ease ${0.3 + i * 0.15}s`
                }}>
                  {step.title}
                </h3>
                <p style={{
                  ...styles.stepDesc,
                  opacity: visible ? 1 : 0,
                  transition: `opacity 0.6s ease ${0.4 + i * 0.15}s`
                }}>
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '1100px', margin: '0 auto', textAlign: 'center', padding: '0 20px' },
  tag: { color: '#c41e3a', fontSize: '12px', fontWeight: 'bold', letterSpacing: '3px', marginBottom: '12px', display: 'block' },

  // WHY CHOOSE US
  whySection: { background: '#f5f7fa', padding: '80px 20px' },
  whyTitle: { color: '#1a3a5c', fontSize: '36px', fontWeight: 'bold', marginBottom: '16px' },
  whySubtitle: { color: '#4a5568', fontSize: '16px', lineHeight: 1.8, marginBottom: '40px', maxWidth: '700px', margin: '0 auto 40px' },
  benefitCard: { borderRadius: '16px', padding: '24px 16px', border: '1px solid #e2e8f0', cursor: 'pointer', textAlign: 'center' },
  benefitIcon: { fontSize: '32px', display: 'block', marginBottom: '12px' },
  benefitTitle: { fontSize: '15px', fontWeight: 'bold', marginBottom: '8px' },
  benefitDesc: { fontSize: '13px', lineHeight: 1.6, margin: 0 },
  dots: { display: 'flex', gap: '8px', justifyContent: 'center', marginTop: '24px' },
  dot: { height: '8px', borderRadius: '4px', cursor: 'pointer', transition: 'all 0.3s ease' },

  // SERVICES
  servicesSection: { background: '#fff', padding: '80px 20px' },
  servicesTitle: { color: '#1a3a5c', fontSize: '36px', fontWeight: 'bold', marginBottom: '16px' },
  servicesSubtitle: { color: '#4a5568', fontSize: '16px', lineHeight: 1.8, marginBottom: '48px', maxWidth: '780px', margin: '0 auto 48px' },
  serviceCard: { background: '#fff', borderRadius: '16px', padding: '28px', border: '2px solid #e2e8f0', cursor: 'pointer' },
  serviceIconBox: { width: '60px', height: '60px', background: 'linear-gradient(135deg, #1a3a5c, #2d5a7b)', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' },
  serviceIcon: { fontSize: '28px' },
  serviceTitle: { color: '#1a3a5c', fontSize: '17px', fontWeight: 'bold', marginBottom: '8px' },
  serviceDesc: { color: '#4a5568', fontSize: '14px', lineHeight: 1.7, marginBottom: '12px' },
  clickHint: { color: '#c41e3a', fontSize: '12px', fontWeight: 'bold', margin: '8px 0 0' },
  expandedBox: { marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #e2e8f0' },
  detailText: { color: '#4a5568', fontSize: '14px', lineHeight: 1.7, marginBottom: '16px' },
  bookBtn: { width: '100%', padding: '12px', background: '#c41e3a', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },

  // 3-STEP PROCESS
  processSection: { position: 'relative', padding: '100px 20px', overflow: 'hidden' },
  processBg: { position: 'absolute', inset: 0, backgroundImage: 'url(https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', filter: 'brightness(0.25)', zIndex: 0 },
  processOverlay: { position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(26,58,92,0.92) 0%, rgba(26,58,92,0.85) 100%)', zIndex: 1 },
  stepCircleOuter: { width: '120px', height: '120px', borderRadius: '50%', border: '2px dashed rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', position: 'relative' },
  stepCircleInner: { width: '90px', height: '90px', borderRadius: '50%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  stepNum: { position: 'absolute', top: '-8px', right: '-8px', background: '#c41e3a', color: '#fff', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', fontWeight: 'bold', boxShadow: '0 4px 12px rgba(196,30,58,0.4)' },
  stepTitle: { color: '#fff', fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' },
  stepDesc: { color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: 1.7 }
};

export default Services;